<template>
  <div v-if="trip.title && trip.info" class="max-w-7xl mx-auto">
    <div
      class="w-full bg-white mb-10 mt-10 flex flex-col xxs:mt-14 xs:mt-18 sm:mt-32 md:flex-row-reverse"
    >
      <figure class="mx-6 md:h-96 sm:mb-5 md:w-1/2 md:mb-0 md:mr-14">
        <img
          class="h-64 w-full rounded-lg object-cover md:w-full md:h-5/6 lg:h-full"
          :src="trip.image"
          :alt="trip.alt"
        >
      </figure>
      <div class="h-full ml-6 mt-5 flex flex-col md:justify-center md:w-1/2 md:mt-0 md:ml-14 lg:mt-12">
        <h1 class="text-2xl lg:text-3xl">
          {{ trip.title }}
        </h1>
        <div id="expand" v-if="trip.info" class="mt-4 h-32 overflow-hidden text-sm lg:text-md" style="white-space: pre-wrap">
          {{ trip.info }}
        </div>
        <span
          class="underline mt-4 mb-10 text-lg font-light cursor-pointer"
          @click="show"
        >{{ showMore }}</span>
      </div>
    </div>
  </div>
</template>

<script setup>

const props = defineProps({
  trip: {
    type: Object,
    required: true
  }
})
const showMore = '+ Vis mer av teksten';

function show() {
  const expand = document.getElementById('expand')
  if (expand.classList.contains('h-32')) {
    expand.classList.replace('h-32', 'h-auto')
  } else {
    expand.classList.replace('h-auto', 'h-32')
  }
}

</script>
